import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-z-edit-notifications',
  templateUrl: './z-edit-notifications.component.html',
  styleUrls: ['./z-edit-notifications.component.scss']
})
export class ZEditNotificationsComponent implements OnInit {

    productId: string | null = null;
    product: any = {
   user_id: null,       // new field for API
  title: '',
  message: '',
  };
   public arrCoupons: any[] = [];


constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService
  ) {}
  
  // Compare function for user dropdown
  compareUsers(userId1: any, userId2: any): boolean {
    return String(userId1) === String(userId2);
  }
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');

    // Load users first, then load notification if editing
    this.apiService.users().subscribe({
      next:(response:any)=> {
        this.arrCoupons = response.data.data || response.data || [] ;
        console.log('Loaded users:', this.arrCoupons.length, 'users');
        console.log('First user:', this.arrCoupons[0]);

        // Now load notification data after users are loaded
        if (this.productId) {
          this.loadProduct(this.productId);
        }
      },
      error:(err)=> {
        console.log('error in fetching users', err)
        // Still try to load notification even if users fail
        if (this.productId) {
          this.loadProduct(this.productId);
        }
      }
    })

  }

// Fetch product details
loadProduct(id: string): void {
  this.apiService.getnotifications(id).subscribe({
    next: (res: any) => {
      const data = res.data;

      // Set the selected user by ID - ensure it's a string to match dropdown
      this.product.user_id = data.user?.id ? String(data.user.id) : null;
      console.log('Selected user ID:', this.product.user_id);
      console.log('Available users:', this.arrCoupons.map(u => ({id: u.id, name: u.name})));

      // Other fields
      this.product.title = data.title;
      this.product.message = data.message;
      this.product.type = data.type;
      this.product.read = data.read;
    },
    error: (err) => {
      console.error('Failed to load product:', err);
      this.toastr.error('Failed to load notification details');
    }
  });
}



    onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.product.image = event.target.files[0];
    }
  }
  // Update product

  
    updateProduct(): void {
    if (!this.productId) return;

    this.apiService.editnotifications(this.productId, this.product).subscribe({
      next: (res) => {
        this.toastr.success('  updated successfully');
        this.router.navigate(['/z-notifications']); // redirect after save
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.toastr.error('Failed to update  ');
      }
    });
  }


}